/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Distinguishes what a <c>PrintAttachmentOption</c> entry refers to.
 */
export enum EnumPrintAttachmentKind {
    /**
     * Another print option, rendered on demand (e.g. an order or weighing slip).
     */
    PrintOption = 0,
    /**
     * A previously uploaded, opaque file with no template to render it from.
     */
    Raw = 1,
}
